import React, { useEffect, useState } from "react";
import axios from "axios";
import {  useNavigate,useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import logo from "../../../assets/images/logo.png";
import { catchError } from '../../helpers/catch-error-client'


const InvoicePrint = () => {
    const navigate = useNavigate();
    const [invoice, setInvoice] = useState(null);
    const params = useParams()

  

    useEffect(() => {
       
        if (params?.work_order_id ) {
            getInvoice();
            
        }


    }, []);

 

    const getInvoice = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-invoice-print-by-work-order-id/"+ params?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setInvoice(response?.data?.invoice)



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                  
                }

            }).catch(function (error) {

                catchError(error,navigate)


            });


    }





    return (
        <>
      {invoice &&
<div className="printonly">
<table width="720px" cellpadding="0" cellspacing="0" align="center" className="heading watermarked" >
              <tr>
                <td className="heading-address" colspan="2" >
                    <img src={logo} width="200" border="0"  />
                    <br/>

                    POST OFFICE BOX 2191<br/>
                    SAN LEANDRO, CA 94577<br/>
                    PHONE:{process.env.REACT_APP_SUPPORT_PHONE_NUMBER} SECURE FAX: {process.env.REACT_APP_SUPPORT_FAX}<br/>
                    MedRecAps Billing&lt;Billing@MedRecAps.Com&gt; <br/>
                </td>

               <td className="heading-invoice"  colspan="2">
                   I N V O I C E
                </td>
            </tr>

            <tr>
                <td  colspan="2" className="heading-client">
                   {invoice["client_company_name"].toLowerCase()} <br/>
                    Attn: Accounts Payable <br/>
                    {invoice["client_address"].toLowerCase()} <br/>
                    {invoice["client_city"].toLowerCase()+", "+invoice["client_state"].toLowerCase()+" "+invoice["client_zip"]} <br/>
                    {"Ph: " + invoice["client_phone"]} 
                    {" Fx: " + invoice["client_fax"]} 
                   
                </td>
                <td colspan="2" align="right" className="heading-work-order">
                    <b>Invoice #: </b>
                    {invoice.work_order_no}<br/>
                    <b>Invoice Date: </b>
                    {invoice.invoice_date_f}<br/>
                    <b>DUE UPON RECEIPT</b>
                </td>

            </tr>

            <tr>
                <td colspan="4" align="center" className="fedral-tax"  >FEDERAL TAX ID: 85-1722093</td>
            </tr>

            <tr className="background-alice-blue" >
                <th width="20%" className="heading-col"  >Item</th> 
                <th width="30%" className="heading-col"  >Description</th> 
                <th width="25%" className="heading-col" ></th> 
                <th  width="25%" align="right" className="heading-col" >Amount</th> 
             </tr>
             <tr className=" paddingtop">
                <td valign="top" align="left" ><b>Facility Fee:</b></td> 
                <td valign="top" align="left" >Medical Records </td> 
                <td valign="top" align="right" >${parseFloat(invoice["invoice_facility_fee"]).toFixed(2)}</td> 
                <td valign="top" align="right" >${parseFloat(invoice["invoice_facility_fee"]).toFixed(2)}</td> 
                </tr>
                 <tr >
                <td valign="top" align="left" >
                    <b>Client Fee: </b>
                </td> 
                <td valign="top" align="left" >Retrieval</td> 
                <td valign="top" align="right" >${parseFloat(invoice["invoice_client_fee"]).toFixed(2)}</td> 
                <td valign="top" align="right" >${parseFloat(invoice["invoice_client_fee"]).toFixed(2)}</td> 
                </tr>
                <tr >
                    <td colspan="2" valign="top" align="left" ><b>Misc Fee:</b></td> 
                 
                <td valign="top" align="right" >${parseFloat(invoice["invoice_misc_fee"]).toFixed(2)}</td> 
                <td valign="top" align="right" >${parseFloat(invoice["invoice_misc_fee"]).toFixed(2)}</td> 
                </tr>
                 <tr className=" paddingtop text-transform-capitalize">
                     <td valign="top" align="left" colspan="2"  >
                         <b>Patient Name:</b> &nbsp;&nbsp;
                         {invoice["patient_last_name"].toLowerCase()+", " +invoice["patient_first_name"].toLowerCase() + " " +invoice["patient_middle_name"].toLowerCase() }<br/>
                    <b>Date of Birth:</b> &nbsp;&nbsp;
                    {invoice["patient_dob"]?invoice["patient_dob"]:""}<br/>
                    <b>Social Sec. #:</b> &nbsp;&nbsp;
                    {invoice["patient_ssn"]?"***-**-"+invoice.patient_ssn.substring(invoice.patient_ssn.length - 4):""}<br/><br/>
                    
                     <b>Requested By:</b> &nbsp;&nbsp;
                     {invoice["wo_request_submitted_by"]?invoice["wo_request_submitted_by"]:""}
                   
                     <br/>
                    <b>Client Reference No.:</b> &nbsp;&nbsp;
                    {invoice["wo_policy_number"]?invoice["wo_policy_number"]:""}<br/><br/>
                </td> 
                
                <td ></td> 
                <td ></td> 
                </tr>
                
                
                
                  <tr className=" ">
                      <td valign="top" rowspan="4" colspan="2" className="heading-col2" >
                           <b>RECORDS FROM:</b><br/>
                           {invoice["facility_name"]}<br/>
                           {"Attn:"+invoice["facility_attn"]}<br/>
                           {invoice["facility_address"]}<br/>
                           {invoice["facility_city"]+", "}
                           {invoice["facility_state"]+" "}
                           {invoice["facility_zip"]}<br/>
                  
                   
                           {invoice["facility_phone"]?"Ph:"+invoice["facility_phone"]+"<br/>":""}
                           {invoice["facility_fax"]?"Ph:"+invoice["facility_fax"]:""}


                
                          
                      </td> 
                <td valign="top" align="right" className="heading-col3" ><b>Subtotal</b></td> 
                
                <td valign="top" align="right"  className="heading-col3">${(invoice?.invoice_facility_fee * 1 + invoice?.invoice_client_fee * 1 + invoice?.invoice_misc_fee * 1-invoice["paid"]).toFixed(2)}</td> 
                </tr>
                 <tr >
                
                <td valign="top" align="right"  className="heading-col3"><b>Total Amount</b></td> 
                
                <td valign="top" align="right" className="heading-col3">${(invoice?.invoice_facility_fee * 1 + invoice?.invoice_client_fee * 1 + invoice?.invoice_misc_fee * 1).toFixed(2)}</td> 
                </tr>
                
                 <tr >
                
                <td valign="top" align="right"  ><b>Paid</b></td> 
               
                <td  align="right"  > 
                  {invoice["paid"]?parseFloat(invoice["paid"]).toFixed(2):"0.00"}    
                </td> 
                </tr>
                
                 <tr >
                
                <td valign="top" align="right"  className="heading-col"><b>Balance due</b></td> 
               
                <td  align="right"  className="heading-col"> 
                   ${(invoice?.invoice_facility_fee * 1 + invoice?.invoice_client_fee * 1 + invoice?.invoice_misc_fee * 1-invoice["paid"]).toFixed(2)}
                </td> 
                </tr>
      
<tr >
                
    <td colspan="2" valign="top" align="left"  className="padding-top-20">
    <b>Any Questions or Concerns: Billing@MedRecAps.Com</b>
    </td> 
               
    <td colspan="2"  align="right"  className="padding-top-20"> 
                  <img src={logo}  width="170" border="0"  />
                </td> 
                </tr>
                
                
                
          
        </table>
        </div>
      

                             }
                               <br/>
                               <br/> <br/>
                               <br/>
                               <br/> <br/>
                             </>
    )

}
export default InvoicePrint;